export const PUBLIC_PAGES_IDS = [
  'login',
  'forgot-password',
  'forgot-password-success',
  'forgot-password-submission',
  'forgot-password-submission-success',
  'forgot-username',
  'forgot-username-success',
  'forbidden',
  'suspended',
  'not-found',
  'error',
];
